<template>
  <component
    ref="orderPdf"
    :is="rootComponent"
    :filename="filename"
  >
<!--    class="w-100 d-lg-flex flex-column flex-fill align-items-center"-->
    <slot />
    <div v-if="container.isOrderNotFound" class="text-h1 color-dark flex flex-center flex-grow-1 mt-80">
      <span>К сожалению, информация не найдена.</span>
    </div>
    <template v-else>
      <slot name="toolbar">
        <component :is="container.toolbar" @send-form="onSendForm" class="pdf-order-section-hide" />
      </slot>

      <div v-if="container.isReadyToDraw" class="vz-personal-order">
        <div class="vz-personal-order-content">
          <div class="vz-personal-order-content-form vz-position-relative">
            <component
              v-if="container.orderSwitcher"
              :is="container.orderSwitcher"
              class="pdf-order-section-hide"
            />
            <div v-if="showPdfDate" class="pdf-order-section-only display-none mb-10">
              <span class="fs-16">{{ dateText }}</span>
            </div>
            <slot name="form">
              <vz-form
                ref="formRef"
                v-model="isValidForm"
                scroll-to-error
                class="vz-personal-order-content-form vz-position-relative"
              >
                <div class="vz-individual-order">
                  <slot name="header">
                    <component :is="container.orderHeader" />
                  </slot>
                  <component :is="container.orderForm" class="vz-personal-order-container" @send-form="onSendForm" />
                  <vz-loader :status-loader="container.totalBlockLoading"/>
                </div>
              </vz-form>
            </slot>
            <component v-if="container.orderFormFooter" :is="container.orderFormFooter" />
          </div>
          <div class="vz-personal-order-total-container pdf-order-section">
            <slot name="total">
              <component :is="container.orderTotal" @send-form="onSendForm" />
            </slot>
          </div>
        </div>

        <div class="vz-personal-order-total-sidebar-container pdf-order-section-hide">
          <slot name="sidebar">
            <client-only>
              <component v-if="container.orderSidebar" :is="container.orderSidebar" @send-form="onSendForm" />
              <vz-sidebar v-else-if="container.sidebarTitle">
                <template #title>
                  <div class="vz-personal-order-total-sidebar-title-price py-20">
                    <slot name="sidebar-title">
                      {{ container.sidebarTitle }}
                    </slot>
                  </div>
                </template>
                <slot name="total">
                  <component :is="container.orderTotal" @send-form="onSendForm" />
                </slot>
              </vz-sidebar>
            </client-only>
          </slot>
        </div>
      </div>

      <slot v-else name="skeleton">
        <vz-order-create-skeleton />
      </slot>
    </template>
  </component>
</template>

<script setup lang="ts">
/** Для Раскомпановки заказоподобных страниц (создание, редактирование, просмотр, мултизаявка, групповой забор, шаблон ...) */
import VzContent from '~/components/personal/vz-content.vue';
import {PropType} from 'vue';
import {OrderContainer} from '~/types/components/order-container';
import VzOrderCreateSkeleton from '~/components/personal/order/vz-order-create-skeleton.vue';
import VzLoader from '~/components/ui-kit/vz-loader.vue';
import VzForm from '~/components/ui-kit/vz-form.vue';
import VzSidebar from '~/components/ui-kit/vz-sidebar.vue';
import VzOrderPdf from '~/components/ui-kit/vz-order-pdf.vue';
import {markRaw} from '@vue/reactivity';
import {useDayjs} from '#dayjs';
const dayjs = useDayjs()

const props = defineProps({
  container: {
    type: Object as PropType<OrderContainer>,
    default: () => ({})
  },
  canBePdf: {
    type: Boolean,
    default: false
  },
  filename: {
    type: String,
    default: 'order'
  },
  showPdfDate: {
    type: Boolean,
    default: false
  }
})

const {$showToast} = useNuxtApp()
const formRef = ref()
const orderPdf = ref()
const isValidForm = ref(true)

provide('validateOrderForm', (silent = false) => {
  return formRef?.value?.validate(silent)
})

const rootComponent = computed(() => {
  return props.canBePdf ? markRaw(VzOrderPdf) : markRaw(VzContent)
})

const dateText = computed((): string => {
  const today = dayjs().format('DD.MM.YYYY, H:mm')
  return `Сформировано ${today}`
})

function createPdf() {
  if (!props.canBePdf) {
    return
  }
  if (props.container.totalBlockLoading) {
    return $showToast({
      variant: 'error',
      title: 'Ошибка создания pdf',
      text: 'Дождитесь загрузки заказа'
    })
  }
  orderPdf.value?.generatePdf()
}

async function onSendForm(confirmed = null) {
  isValidForm.value = await formRef?.value?.validate(false)
  if (!isValidForm.value) {
    return
  }

  await props.container?.onSendForm?.(confirmed)
}

provide('createPdf', createPdf)
</script>

<style lang="scss">

</style>
